import { all, put, takeEvery } from "@redux-saga/core/effects";
import {
  calculateDistance,
  liveLocationUpdateTime,
  movePerSecond
} from "../../Utils/constants";
import { setErrorStatus } from "../status/action";
import store from "../store";
import { isValidObject } from "../../Services/validators";

export const actionTypes = {
  ADD_LOCATIONS_DATA: "ADD_LOCATIONS_DATA",
  ADD_USER_DISTANCE: "ADD_USER_DISTANCE",
  SET_USER_LOCATION: "SET_USER_LOCATION",
  ADD_SELECTED_LOCATION: "ADD_SELECTED_LOCATION"
};

function* addLocationsDataWorker(action) {
  try {
    setLocationsLoading(true);
    yield put({
      type: "SET_LOCATIONS_DATA",
      payload: { data: action.payload.data }
    });
    setLocationsLoading(false);
  } catch (error) {
    setLocationsLoading(false);
    setErrorStatus(error);
  }
}

function* addUserDistanceWorker() {
  try {
    const locations = store.getState().locations;
    const currentLocation = locations.currentLocation;
    const selectedLocation = locations.selectedLocation;

    if (typeof selectedLocation !== "string") {
      return console.warn(
        "selectedLocation is expected as string but got:",
        selectedLocation
      );
    }
    const geoLoc = locations?.data?.[selectedLocation]?._geoloc;

    if (isValidObject(currentLocation)) {
      yield put({
        type: "SET_USER_DISTANCE",
        payload: {
          distance: calculateDistance(
            {
              latitude: geoLoc?.lat,
              longitude: geoLoc?.lng
            },
            currentLocation
          )
        }
      });
    } else {
      yield put({
        type: "SET_USER_DISTANCE",
        payload: {
          distance: null
        }
      });
    }
  } catch (error) {
    console.error(error);
  }
}

function* setUserLocationWorker(action) {
  try {
    const currentLocation = action.payload.currentLocation;
    const locations = store.getState().locations;
    const previousLocation = locations.currentLocation;
    const currentTime = +new Date();

    if (!isValidObject(currentLocation)) {
      console.warn(
        "getting error from setUserLocationWorker the current locations is:",
        currentLocation
      );

      return yield put({
        type: "SET_USER_CURRENT_LOCATION",
        payload: {
          data: null
        }
      });
    }

    if (
      !isValidObject(previousLocation) ||
      typeof previousLocation.latitude !== "number" ||
      typeof previousLocation.longitude !== "number"
    ) {
      yield put({
        type: "SET_USER_CURRENT_LOCATION",
        payload: {
          data: {
            ...currentLocation,
            timestamp: currentTime
          }
        }
      });
    } else {
      const distance = calculateDistance(previousLocation, currentLocation);
      const lastTimeStamp = previousLocation.timestamp;
      const timeDifference = (currentTime - lastTimeStamp) / 1000;

      if (
        movePerSecond * timeDifference >= distance ||
        timeDifference >= liveLocationUpdateTime
      ) {
        yield put({
          type: "SET_USER_CURRENT_LOCATION",
          payload: {
            data: {
              ...currentLocation,
              timestamp: currentTime
            }
          }
        });
      }
    }
  } catch (error) {
    console.error("Error in setUserLocationWorker:", error);
  }
}

function* addSelectedLocationWorker(action) {
  try {
    yield setLocationsLoading(true);
    yield put({
      type: "SET_SELECTED_LOCATION",
      payload: { data: action.payload.data }
    });
    yield setLocationsLoading(false);
  } catch (error) {
    yield setLocationsLoading(false);
    setErrorStatus(error);
  }
}

export default function* locationsWatcher() {
  yield all([
    takeEvery("ADD_LOCATIONS_DATA", addLocationsDataWorker),
    takeEvery("ADD_USER_DISTANCE", addUserDistanceWorker),
    takeEvery("SET_USER_LOCATION", setUserLocationWorker),
    takeEvery("ADD_SELECTED_LOCATION", addSelectedLocationWorker)
  ]);
}

function* setLocationsLoading(bool) {
  yield put({
    type: "SET_LOCATIONS_LOADING",
    payload: {
      loading: bool
    }
  });
}
